import { usePetitionEditPageState } from 'src/app/pages/petitionEditV2/pageContext';
import type { Tag } from 'src/app/shared/components/tags';

export function useCategoryTags() {
	const [state, mutations] = usePetitionEditPageState();

	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	const formTags = state.formState.tags.value || [];
	const selectedTags = formTags.map((tagName) => ({ name: tagName }));

	const onSelect = (tag: Tag, _: readonly Tag[]) => {
		mutations.addTag(tag.name);
	};

	const onRemove = (tag: Tag, _: readonly Tag[]) => {
		mutations.removeTag(tag.name);
	};

	return {
		data: {
			selectedTags,
		},
		actions: {
			onSelect,
			onRemove,
		},
	};
}
